import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "icon"];
  static classes = ["hidden"];

  connect() {
    // Start collapsed by default
    this.close();
  }

  toggle() {
    if (this.contentTarget.classList.contains(this.hiddenClass)) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.contentTarget.classList.remove(this.hiddenClass);
    this.iconTarget.style.transform = "rotate(180deg)";
  }

  close() {
    this.contentTarget.classList.add(this.hiddenClass);
    this.iconTarget.style.transform = "rotate(0deg)";
  }
}
